import { commonHttpApi } from './commonHttp.api';
import { ApiError } from './ApiError';
import i18n from '@app/i18n';
import { Method } from 'axios';
import { ApiErrorData } from './http.api';

// Centralized error handling
export const handleApiError = (err: any): never => {
  const status = err?.response?.status;
  const envelope = err?.response?.data; // { data: { errorId }, result: {...} }
  const result = envelope?.result;
  const errorId = envelope?.data?.errorId;

  const message =
    result?.message ||
    err?.message ||
    'Server error';

  const code = result?.code;

  throw new ApiError<ApiErrorData>(message, {
    message,
    code,
    success: false,
    status,
    errorId,
  });
};

// Utility for handling API requests
export const apiRequest = async <T>(
  method: Method,
  url: string,
  payload?: any
): Promise<T> => {
  try {
    const requestOptions = {
      method,
      url,
      params: method === 'GET' ? (payload?.params ?? payload) : undefined,
      data: method !== 'GET' ? (payload?.data ?? payload) : undefined,
    };

    const { data } = await commonHttpApi.request<T>(requestOptions);
    return data;
  } catch (err) {
    handleApiError(err);      
    throw err as never;      
  }
};